interface JsonTypeDisplayProps {
  value: unknown;
}

export function JsonTypeDisplay({ value }: JsonTypeDisplayProps) {
  if (value === null || value === undefined) {
    return <span className="text-muted-foreground">null</span>;
  }

  if (typeof value === "string") {
    return (
      <span className="font-mono text-foreground break-all">"{value}"</span>
    );
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return <span className="font-mono text-info">{String(value)}</span>;
  }

  // For objects, we'll use the full JsonViewer
  return null;
}
